import { persistReducer, REHYDRATE } from "redux-persist";
import storage from "redux-persist/es/storage";

const PERSIST_KEY = "z-catalog-pager-settings";

import { SET_LIMIT, FETCH_ENDED, RESET, PAGER_DEFAULT_LIMIT, PAGER_DEFAULT_SORT, PAGER_DEFAULT_DIR } from "./constants";

const initialState = {
  count: 0,
  offset: 0,
  limit: PAGER_DEFAULT_LIMIT,
  sort: PAGER_DEFAULT_SORT,
  dir: PAGER_DEFAULT_DIR,
};

function pager(state = initialState, action) {
  switch (action.type) {
    case FETCH_ENDED:
      return action.payload.pager;

    case SET_LIMIT:
      return {
        ...state,
        limit: action.payload,
      };

    case RESET:
      return {
        ...initialState,
        limit: state.limit,
      };

    case REHYDRATE:
      return action.key === PERSIST_KEY
        ? {
            ...initialState,
            ...action.payload,
          }
        : state;

    default:
      return state;
  }
}

const pagerConfig = {
  key: PERSIST_KEY,
  storage: storage,
  debug: false,
  whitelist: ["limit"],
};

export default persistReducer(pagerConfig, pager);
